import * as React from "react";
const SvgVehicleInspectionLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 149 149"
    {...props}
  >
    <circle cx={74.5} cy={74.5} r={72.5} stroke="#FFA100" strokeWidth={4} />
    <path
      fill="#FFA100"
      d="M33.75 107.75h82.5v-67.5h-82.5v67.5ZM37.5 44h75v60h-75V44Zm63.75 11.25h-52.5V51.5h52.5v3.75ZM60 62.75V59h30v3.75H60Zm45 22.5h3.75a14.982 14.982 0 0 1-10.598 14.3 14.982 14.982 0 0 1-16.783-5.927 14.977 14.977 0 0 1 17.95-22.308l-1.384 3.487A11.25 11.25 0 1 0 105 85.25Zm2.43-12.397 2.64 2.666-16.327 16.125-7.317-7.317 2.651-2.65 4.68 4.68 13.673-13.504Z"
    />
    <path
      fill="#FFA100"
      d="M47.821 85.402a4.255 4.255 0 1 0 0 8.51 4.255 4.255 0 0 0 0-8.51Zm0 6.05a1.795 1.795 0 1 1 0-3.59 1.795 1.795 0 0 1 0 3.59ZM63.338 85.402a4.255 4.255 0 1 0 0 8.51 4.255 4.255 0 0 0 0-8.51Zm0 6.05a1.795 1.795 0 1 1 0-3.59 1.795 1.795 0 0 1 0 3.59Z"
    />
    <path
      fill="#FFA100"
      d="m70.003 81.769-2.202-2.7a3.192 3.192 0 0 0-2.474-1.175h-5.492v4.63h-1.252v-5.756h5.382v-2.002H56.33v2.377H40.126v5.382l10.128 1.922a5.76 5.76 0 0 1 3.325 5.21c0 .043-.006.083-.006.125h4.016c0-.042-.006-.082-.006-.124a5.764 5.764 0 0 1 5.757-5.757c2.875 0 5.258 2.121 5.682 4.88h.637c.588 0 1.064-.477 1.064-1.064v-3.93a3.19 3.19 0 0 0-.719-2.019Zm-25.467.228-1.032-.183v-3.17h1.032v3.353Zm4.412.785-1.033-.184v-3.953h1.033v4.137Zm4.41.788-1.032-.183v-4.742h1.033v4.925Zm8.805-1.371v-2.504h3.239c.284 0 .549.126.728.346l1.76 2.158h-5.727Z"
    />
  </svg>
);
export default SvgVehicleInspectionLogo;
